import React from 'react'
import PropTypes from 'prop-types'
import {Stack, Box, useStyleConfig} from '@chakra-ui/react'
import NewsletterModal from './newsletter-modal'
import BenefitBar from './benefit-bar'

const PreFooter = ({data}) => {
    const styles = useStyleConfig('PreFooter')

    const {benefit_group, subscribe_group} = data
    return (
        <Stack {...styles.preFooterContainer} data-testid="pre-footer-container">
            <Box {...styles.benefitContainer} data-testid="benefit-container">
                <BenefitBar benefitGroup={benefit_group} />
            </Box>
            <Box {...styles.newsletterContainer} data-testid="newsletter-container">
                <NewsletterModal subscribeGroup={subscribe_group} />
            </Box>
        </Stack>
    )
}

PreFooter.propTypes = {
    data: PropTypes.shape({
        benefit_group: PropTypes.array,
        subscribe_group: PropTypes.object,
    }),
}

export default PreFooter
